import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import ProfileDetails from '../ProfileDetails/ProfileDetails';
import DropdownMenuElemToggle from '../../../components/DropDownMenu/DropdownMenuElemToggle/DropdownMenuElemToggle';
import styles from './Settings.module.scss';
import cn from 'classnames';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { persistDarkMode } from '../../../helpers/darkMode';
import { setDarkMode } from '../../../store/reducers/Settings/slice';
const Settings = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const darkMode = useAppSelector((state) => state.settings.darkMode);
    const handleChange = () => {
        dispatch(setDarkMode(!darkMode));
        persistDarkMode(!darkMode);
    };
    return (_jsx(ProfileDetails, Object.assign({ className: cn(styles.element, 'd-flex flex-column'), title: t('settings') }, { children: _jsx(DropdownMenuElemToggle, { color: 'grey', label: t('switch_menu_theme_to_the_dark_mode'), onClick: handleChange, checked: darkMode }) })));
};
export default Settings;
